import { ProfileRolesUpdateRequest } from '@portal/models/profileRolesUpdateRequest';

export interface AgentRolesUpdateWithId extends ProfileRolesUpdateRequest {
  id: number;
}
